import React from 'react';
import { YStack } from 'smoothie';

import { GroveSimpleModal } from '../../common/components/GroveSimpleModal';
import type { CreateGuideDto } from '../types/GuideTypes';
import { CreateGuideForm } from './CreateGuideForm';

interface GuideModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (data: CreateGuideDto) => Promise<void>;
    isSubmitting: boolean;
}

export const GuideModal = ({
    isOpen,
    onClose,
    onSubmit,
    isSubmitting,
}: GuideModalProps) => {
    return (
        <GroveSimpleModal isOpen={isOpen} onClose={onClose} hasCloseButton>
            <YStack width={600} height="80vh" overflow="scroll">
                <CreateGuideForm
                    onSubmit={onSubmit}
                    onCancel={onClose}
                    isSubmitting={isSubmitting}
                />
            </YStack>
        </GroveSimpleModal>
    );
};
